import React from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSwitcher.css';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    // Update RSuite locale as well
    const event = new CustomEvent('languageChange', { detail: lng });
    window.dispatchEvent(event);
  };

  // Show question in opposite language so users know where to click
  const questionText = i18n.language === 'fr' ? 'Do you speak' : 'Vous parlez';
  
  return (
    <div className="language-switcher">
      <span className="language-question">{questionText}</span>
      <button 
        className={`flag-button ${i18n.language === 'fr' ? 'active' : ''}`}
        onClick={() => changeLanguage('fr')}
        title="Français"
      >
        🇫🇷
      </button>
      <button 
        className={`flag-button ${i18n.language === 'en' ? 'active' : ''}`}
        onClick={() => changeLanguage('en')}
        title="English"
      >
        🇬🇧
      </button>
    </div>
  );
};

export default LanguageSwitcher;